<template>
	<div class="wrapper auth">
		<div class="container">
			<div class="row">
				<div class="col-lg-6 d-none d-lg-block">
					<h2 class="schoolName" v-if="school.name">{{ school.name }}</h2>
					<h1 class="pageTitle">Booking<span>system</span></h1>
					<p class="pageDescription">På de næste sider kan du se og tilmelde køretimer.</p>

					<div class="bottomMenu">
						<div class="item"><DownloadAppModal></DownloadAppModal></div>
						<div class="item"><ResetPassword></ResetPassword></div>
						<div class="item"><InEnglishModal></InEnglishModal></div>
					</div>
				</div>
				<div class="col-lg-5 offset-lg-1">
					<LoginForm></LoginForm>
					<div class="d-block d-lg-none text-center">
						<ResetPassword></ResetPassword>
					</div>
				</div>				
			</div>
		</div>
	</div>
</template>

<style lang="sass">
@import '@/assets/scss/auth.scss';
</style>


<script>
import LoginForm from '@/components/auth/LoginForm.vue';
import ResetPassword from '@/components/auth/ResetPassword';
import DownloadAppModal from '@/components/auth/DownloadAppModal';
import InEnglishModal from '@/components/auth/InEnglishModal';

export default {
	name: 'login',
	components: {
		LoginForm, ResetPassword,
		DownloadAppModal, InEnglishModal,
	},
	props: ['schoolName'],
	data: function() {
		return {
			school: {
				name: '',
			},
		}
	},

	created() {
		this.handleOnLoad();
	},

	methods: {
		handleOnLoad() {
			if(this.schoolName) {
				this.setSchoolNameCookie();
			}

			const schoolNameCookieValue = document.cookie.replace(/(?:(?:^|.*;\s*)schoolName\s*\=\s*([^;]*).*$)|^.*$/, "$1");
			
			const schoolName = schoolNameCookieValue ? schoolNameCookieValue:'';
			this.school.name = schoolName;
			this.$router.push('/login');
		},
		setSchoolNameCookie() {
			let expiresIn = new Date(Date.now());
			expiresIn.setFullYear(expiresIn.getFullYear()+1);
			document.cookie = `schoolName=${this.schoolName};expires=${expiresIn.toUTCString()};path=/`;
		}
	}
}
</script>


